module.exports = __webpack_public_path__ + "img/takvim.919fb08b.png";